import { render } from "./NavSubmenu.vue?vue&type=template&id=2296d47a&scoped=true&lang=pug"
import script from "./NavSubmenu.vue?vue&type=script&lang=ts"
export * from "./NavSubmenu.vue?vue&type=script&lang=ts"

import "./NavSubmenu.vue?vue&type=style&index=0&id=2296d47a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2296d47a"

export default script